import { combineReducers } from 'redux'
import LoadingReducer from '@SharedReducers/loading.reducer'

const SharedReducers = combineReducers({
    loadings: LoadingReducer,
})

export default SharedReducers
export type RootState = ReturnType<typeof SharedReducers>
